import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-86ef855a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "build-environment-badge"
};
import { computed } from 'vue';
import { resolveEnvironmentBadge } from '@/utils/buildEnvironmentBadge.cjs';
export default {
  __name: 'BuildEnvironmentBadge',
  setup(__props) {
    const badge = computed(() => resolveEnvironmentBadge({
      appVersion: process.env.VUE_APP_VERSION,
      env: process.env.VUE_APP_BUILD_ENV || process.env.ENV,
      nodeEnv: process.env.NODE_ENV
    }));
    return (_ctx, _cache) => {
      return badge.value.visible ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(badge.value.text), 1)) : _createCommentVNode("", true);
    };
  }
};